import React from 'react';
import { Section } from './ui/Section';
import { PRODUCT } from '../data/content';
const paragraphs = ['Hace 10 años organizo mis propios viajes y, con el tiempo, entendí que un buen itinerario no se construye solamente juntando información.', 'Hoy podés preguntarle a una inteligencia artificial qué ciudades visitar o pedirle que arme una ruta en segundos. Pero hay cosas que aparecen recién cuando viajás: cuánto cansan realmente algunos traslados, qué conviene reservar antes, cuándo ahorrar puede terminar saliendo más caro y qué pequeños errores pueden complicarte varios días del viaje.', 'Por eso creé Europa por Primera Vez: para reunir información práctica, herramientas y aprendizajes nacidos de experiencias reales de viaje.'];
export function AboutCaro() {
  return <Section tone="sand" className="py-14 sm:py-16 lg:py-20" data-id="element-15" data-mp="2kh4c1yc277cx">
      <div className="grid grid-cols-1 items-center gap-8 sm:grid-cols-[0.72fr_1.28fr] sm:gap-10" data-id="element-16" data-mp="2kf9qchsyrb7s">
        <img src={PRODUCT.caroPhoto} alt="Caro, creadora de la guía Europa por Primera Vez" className="mx-auto w-[68%] max-w-[260px] rounded-xl object-cover shadow-[0_26px_40px_-28px_rgba(27,51,64,0.5)] sm:w-full sm:max-w-none" data-id="element-17" data-mp="2fhreaijngfvk" />

        <div className="text-center sm:text-left" data-id="element-18" data-mp="2ca8gnqti1rzj">
          <p className="font-sans text-[10px] font-medium uppercase tracking-[0.22em] text-caribe" data-id="element-19" data-mp="2cbjjnof4evpl">
            Quién está detrás de la guía
          </p>
          <h2 className="mt-3 font-display text-[28px] font-bold leading-none text-oceano sm:text-[38px]" data-id="element-20" data-mp="1kjc30nzm7jb7">
            Hola, soy Caro
          </h2>

          <div className="mt-4 space-y-3.5" data-id="element-21" data-mp="1ol60yoife97o">
            {paragraphs.map(paragraph => <p key={paragraph.slice(0, 20)} className="font-sans text-[12.5px] leading-relaxed text-hierro sm:text-[13.5px]" data-id="element-22" data-mp="1tjh8gsl907mq">
                {paragraph}
              </p>)}
          </div>

          <p className="mt-6 font-display text-[19px] font-bold leading-snug text-oceano sm:text-[23px]" data-id="element-23" data-mp="34zp5yfltosrj">
            La IA puede darte información.{' '}
            <span className="text-caribe" data-id="element-24" data-mp="3a03f60z5u8r5">La experiencia te ayuda a saber qué hacer con ella.</span>
          </p>
          <p className="mt-3 font-sans text-[12.5px] leading-relaxed text-oceano/70 sm:text-[13px]" data-id="element-25" data-mp="2fas653fjf12s">
            No quiero organizar tu viaje por vos. Quiero darte mejores herramientas para que lo
            organices vos.
          </p>
        </div>
      </div>
    </Section>;
}